'use strict';

const isNumber = (value) => typeof value === 'number' && !Number.isNaN(value);
const toNumber = (value) => {
    if (value === '')
        return null;
    const number = Number(value);
    return isNumber(number) ? number : null;
};
const random = ({ min = 0, max }) => min + Math.floor(Math.random() * (max - min));

exports.isNumber = isNumber;
exports.random = random;
exports.toNumber = toNumber;
//# sourceMappingURL=number.js.map
